// Grievance Summaries — per-grievance narrative cards for quick read-through.
import React from "react";
import { ReportShell, Card, Pill, NotifyMark, val, fmtDate, EmptyState } from "./_shared";
import { CATEGORIES, STATUSES, categoryLabel, statusLabel, complainantLabel } from "../grievanceModel";

export default function GrievanceSummaries({ records = [] }) {
  const sorted = [...records].sort((a, b) => String(b.dateReceived || "").localeCompare(String(a.dateReceived || "")));

  return (
    <ReportShell title="Grievance Summaries" subtitle="Narrative cards — resident, category, what happened, resolution, outcome.">
      {sorted.length === 0 ? (
        <EmptyState>No grievances for this scope.</EmptyState>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(330px,1fr))", gap: 14 }}>
          {sorted.map((r) => {
            const st = STATUSES[r.status] || {};
            return (
              <Card key={r.id} style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
                  <div style={{ fontSize: 14, fontWeight: 800, color: "var(--ed-ink)" }}>{val(r.residentName, { missing: r.complainantType !== "anonymous" })}</div>
                  <Pill label={statusLabel(r.status)} color={st.color} bg={st.bg} border={st.border} />
                </div>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", fontSize: 12, color: "var(--ed-muted)" }}>
                  <Pill label={categoryLabel(r.category)} color={CATEGORIES[r.category]?.color} bg={CATEGORIES[r.category]?.bg} />
                  <span>· {complainantLabel(r.complainantType)}</span>
                  <span>· {val(fmtDate(r.dateReceived))}</span>
                  <span style={{ marginLeft: "auto" }}>Notice: <NotifyMark sent={r.residentNotificationSent} /></span>
                </div>
                <Block label="What happened" text={r.narrative} />
                <Block label="Resolution" text={r.outcome} missing />
                <div style={{ fontSize: 11.5, color: "var(--ed-muted-2)", marginTop: "auto", paddingTop: 4, borderTop: "1px solid var(--ed-line-2)" }}>
                  {r.facilityName} · {r.facilityCcn} · Assigned: {val(r.assignedTo)}
                </div>
              </Card>
            );
          })}
        </div>
      )}
    </ReportShell>
  );
}

function Block({ label, text, missing }) {
  return (
    <div>
      <div style={{ fontSize: 10.5, fontWeight: 700, color: "var(--ed-muted-2)", textTransform: "uppercase", letterSpacing: ".05em", marginBottom: 3 }}>{label}</div>
      <div style={{ fontSize: 13, color: "var(--ed-ink-2)", lineHeight: 1.55 }}>{val(text, { missing })}</div>
    </div>
  );
}
